import { createSelector } from 'reselect';

const selectDBAPublishLogs = (state: any) => state.dbaPublishLogs;


export const selectDBAPublishLogsCurrentItem = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.current);

export const selectDBAPublishLogsListItems = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.list);

export const selectDBAPublishLogsItemById = (itemId: any) =>
    createSelector(selectDBAPublishLogsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBAPublishLogsQueryItems = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.query);

export const selectDBAPublishLogsCreatedItem = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.create);

export const selectDBAPublishLogsUpdatedItem = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.update);

export const selectDBAPublishLogsReadItem = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.read);

export const selectDBAPublishLogsDeletedItem = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.delete);

export const selectDBAPublishLogsSearchedItems = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.search);

export const selectDBAPublishLogsItemsCount = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.count);

export const selectDBAPublishLogsItemsFilter = createSelector([selectDBAPublishLogs], (dbaPublishLogs) => dbaPublishLogs.filter);